import React from 'react';
import styles from '../../assets/styles/styles.less';
import MediaQuery from 'react-responsive';

import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';


import DetailsDesktop from './DetailsDesktop';
import DetailsMobile from './DetailsMobile';
import { Loading } from '../Controls';
import { hashHistory } from 'react-router';

import { 
    detailsAddField, 
    detailsDeleteField, 
    detailsFieldOnChange, 
    detailsFieldOnBlur } from '../../actions/actions.js';

class Details extends React.Component {

    componentWillMount(){
        if (!this.props.reducer
        || this.props.reducer.success   // submitted already    
        || Object.keys(this.props.reducer.charity).length === 0) hashHistory.push('/');
    }
	
    render() {
        return (
            <div>
                <DetailsMobile {...this.props}/>
                { this.props.reducer.loading ? <Loading /> : null }
            </div> 
        )
    }

};

function mapStateToProps(state) {
  return {
    reducer: state.detailsReducer
  }
};

function matchDispatchToProps(dispatch) {
  return bindActionCreators({
    detailsAddField, 
    detailsDeleteField, 
    detailsFieldOnChange, 
    detailsFieldOnBlur
}, dispatch)
};

export default connect(mapStateToProps, matchDispatchToProps)(Details);


// WEBPACK FOOTER //
// ./components/Details/Details.js